import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { FileName } from '../../FileName';
import { FileUploadField } from '@/components/UI/FileUploadField';
import { ALLOWED_FILE_SIZES, BANK_STATEMENT_ALLOWED_FORMATS } from '@/helpers/common';
import { checkForValidFile } from '@/helpers/utils';
import { Tooltip } from '../../Tooltip';
import s from './index.module.scss';

export const BankStatementUploadField = ({
  name,
  value = [],
  error,
  onBlur,
  onChange,
  onError,
  onRemove,
}) => {
  const { t } = useTranslation('components');
  return (
    <div className={s.wrapper}>
      <div className={classnames(s.label, 'f-16')}>
        {t('bank_statement_upload.bank_statement_label')}
        <Tooltip
          renderContent={() => (
            <div className={s.tooltip_text}>{t('bank_statement_upload.tooltip_text')}</div>
          )}
        />
      </div>
      {value.length ? (
        <div className={s.files}>
          {value.map((file, index) => (
            <FileName key={index} file={file} onRemove={onRemove} />
          ))}
        </div>
      ) : (
        <FileUploadField
          name={name}
          multiple={false}
          label={t('bank_statement_upload.upload_document_label')}
          description={t('bank_statement_upload.upload_file_up_to', { size: '1Mb' })}
          accept={BANK_STATEMENT_ALLOWED_FORMATS}
          error={!!error}
          className={s.upload}
          onBlur={onBlur}
          onChange={e => {
            const files = Object.keys(e.target.files).map(idx => e.target.files[idx]);
            const validFiles = files.filter(file => {
              const { isValid, type, size } = checkForValidFile(
                file,
                BANK_STATEMENT_ALLOWED_FORMATS,
                ALLOWED_FILE_SIZES['1mb'],
              );

              !isValid && size && onError(t('bank_statement_upload.file_size_error'));
              !isValid && type && onError(t('bank_statement_upload.file_type_error'));

              return isValid;
            });
            onChange(validFiles);
          }}
        />
      )}
    </div>
  );
};
